<template>
  <div class="container">
    <ExternalQueryList
        endpoint="/api/v2/partnership-activity-mails"
        :endpoint-filters="{company_id: company.data.id}"
        :headlines="headlines"
        :can-update="() => true"
        @show="partnershipActivityMail => $router.push('/companies/'+company.data.id+'/partnership-activity-mails/'+partnershipActivityMail.id)"
    >
      <template v-slot:default="{ row: partnershipActivityMail }">
        <td>
          <router-link :to="'/companies/'+company.data.id+'/partnership-activity-mails/'+partnershipActivityMail.id">
            {{ partnershipActivityMail.attributes.created_at | datetime }}
          </router-link>
        </td>

        <td>
          {{ partnershipActivityMail.attributes.portal_name }}
        </td>

        <td>
          {{ partnershipActivityMail.attributes.recipients.length }}
        </td>

        <td>
          {{ partnershipActivityMail.attributes.sent_at | datetime }}
        </td>
      </template>
    </ExternalQueryList>
  </div>
</template>

<script>
import ExternalQueryList from '@/components/Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  model: {
    prop: 'company',
  },

  props: {
    company: {
      required: true,
    }
  },

  computed: {
    headlines() {
      return [
        {width: 6, text: 'Date'},
        {width: 6, text: 'Portal'},
        {width: 5, text: 'Recipients'},
        {width: 5, text: 'Sent At'},
      ]
    },
  }
}
</script>
